// extracted by mini-css-extract-plugin
export default {"lucideStroke":"BookingPageIcons_lucideStroke__cQfwW"};